import { Fonts as KrispyFonts } from '@krispy/typography/web';

const Fonts = KrispyFonts;

export default Fonts;
